// Configuration for different environments
const config = {
  development: {
    API_URL: "https://api.dandun.app",
    ENVIRONMENT: "development"
  },
  production: {
    API_URL: "https://api.dandun.app", 
    ENVIRONMENT: "production"
  }
};

// Get the current environment
const environment = process.env.NODE_ENV || 'development';

// Export the configuration for the current environment
export default config[environment];
